// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"454":"20e8798e","460":"5ba886b3"}[chunkId] + ".chunk.css";
};